module.exports = {"TXTWCL_Account_details":{"id":"TXTWCL_Account_details","defaultMessage":"Dane konta"}}